import * as React from "react"
import { cn } from "./lib/cn"

function AmbientBlobs({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="ambient-blobs"
      className={cn("pointer-events-none absolute inset-0 overflow-hidden rounded-[inherit]", className)}
      {...props}
    >
      <div className="absolute -top-4 -right-4 h-24 w-24 rounded-full bg-purple-400/15 blur-3xl dark:bg-purple-500/10" />
      <div className="absolute -bottom-4 -left-4 h-20 w-20 rounded-full bg-blue-400/10 blur-3xl dark:bg-blue-500/8" />
      <div className="absolute top-1/2 left-1/2 h-16 w-16 -translate-x-1/2 -translate-y-1/2 rounded-full bg-indigo-400/10 blur-3xl dark:bg-indigo-500/8" />
    </div>
  )
}

export { AmbientBlobs }
